import { tickerTopics } from "@/mocks/homeData";

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden">
      {/* editorial warm background */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-background-100 via-background-50 to-primary-100/60" aria-hidden="true"></div>
      <div className="absolute -right-24 -top-24 -z-10 h-96 w-96 rounded-full bg-primary-200/50 blur-2xl float-slower" aria-hidden="true"></div>
      <div className="absolute left-1/4 top-24 -z-10 h-56 w-56 rounded-full bg-accent-200/40 blur-2xl float-slow" aria-hidden="true"></div>
      <div className="absolute inset-y-0 right-10 hidden -z-10 flex-col items-center justify-center gap-6 lg:flex" aria-hidden="true">
        <i className="ri-megaphone-fill text-3xl text-primary-300 float-slow"></i>
        <i className="ri-eye-fill text-2xl text-accent-500 float-slower"></i>
        <i className="ri-flashlight-fill text-3xl text-primary-200 float-slow"></i>
        <i className="ri-bubble-chart-fill text-2xl text-accent-400 float-slower"></i>
      </div>

      <div className="mx-auto flex min-h-[78vh] max-w-7xl flex-col justify-center px-4 pb-10 pt-28 md:px-6 md:pt-32">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/80 px-4 py-1.5 text-xs font-medium text-primary-800 ring-1 ring-primary-200/70">
            <span className="h-2 w-2 rounded-full bg-primary-500"></span>
            每日更新 · 理性吃瓜不传谣
          </span>

          <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-foreground-950 sm:text-5xl lg:text-6xl">
            今日大瓜是什么？
            <br />
            <span className="text-primary-600">一分钟看懂</span>今天的瓜
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-8 text-foreground-700 md:text-lg">
            “今日大瓜”是当下被热议的娱乐与流行话题。我们每天帮你把碎片化的热搜整理成
            <strong className="font-semibold text-primary-700">讲的是谁 · 因何被议论 · 焦点在哪 · 最新进展</strong>，
            不用翻一堆帖子，点开这一页就能理清来龙去脉、跟上最新进度。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#focus"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-base font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              看今天头号大瓜
              <i className="ri-arrow-right-line ml-2 text-lg" aria-hidden="true"></i>
            </a>
            <a
              href="#rank"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-background-50/80 px-7 py-3.5 text-base font-medium text-foreground-900 ring-1 ring-background-300 transition-colors hover:ring-primary-300 hover:text-primary-700"
            >
              逛热门瓜榜
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-foreground-600">
            <span className="inline-flex items-center gap-2 whitespace-nowrap"><i className="ri-time-line text-primary-600" aria-hidden="true"></i>实时热点聚合</span>
            <span className="inline-flex items-center gap-2 whitespace-nowrap"><i className="ri-voiceprint-line text-accent-600" aria-hidden="true"></i>中立客观转述</span>
            <span className="inline-flex items-center gap-2 whitespace-nowrap"><i className="ri-shield-check-line text-primary-600" aria-hidden="true"></i>坚持理性表达</span>
          </div>
        </div>
      </div>

      {/* hot ticker */}
      <div className="border-y border-primary-200/60 bg-primary-600 py-3">
        <div className="flex overflow-hidden">
          <div className="marquee-track flex shrink-0 items-center gap-8 pr-8">
            {[...tickerTopics, ...tickerTopics].map((t, i) => (
              <span key={i} className="flex items-center gap-2 whitespace-nowrap text-sm text-background-50">
                <i className="ri-flashlight-fill text-accent-300" aria-hidden="true"></i>
                <span className="rounded bg-accent-500 px-1.5 py-0.5 text-[11px] font-bold text-foreground-950">{t.tag}</span>
                <span>{t.text}</span>
                <span className="text-background-100/70">{t.hot}万热度</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}